<template>
<div class="chapter">
<div class="inner_page">
<div class="body">
<p class="SP"> </p>
<p class="DED"><span epub:type="pagebreak" id="pg_v" title="v"><span class="ePub-I">For David. Not only do you see me—you see through me, which is even better.</span></span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?6a7339ba